<template>
  <div>
    <Header title="Times procurando Treino"></Header>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3">
          <!-- <h2>filtros</h2> -->
          <p class="lead">Esses times ao lado estão procurando outro time para treinar.</p>
          <p
            class="lead"
          >Você pode marcar treino com estes times clicando no mapa que deseja jogar ou</p>

          <b-button
            v-b-modal.modalAnnounce
            block
            variant="dark"
            size="md"
          >procure treino com seu time</b-button>

          <b-modal
            id="modalAnnounce"
            title="Procurar treino"
            ref="modalAnnounce"
            @ok="handleAnnounceOk"
          >
            <form @submit.stop.prevent="handleAnnounceSubmit">
              <b-form-group description label="Seu time">
                <b-form-select required v-model="announce.team_a_id" class="mb-3">
                  <option
                    v-for="team in currentUserTeams"
                    :key="team.id"
                    :value="team.slug"
                  >{{ team.name }}</option>
                </b-form-select>
              </b-form-group>

              <b-form-group description label="Mapa">
                <b-form-select multiple required v-model="announce.maps" class="mb-3">
                  <option>de_inferno</option>
                  <option>de_dust2</option>
                  <option>de_mirage</option>
                  <option>de_cache</option>
                  <option>de_overpass</option>
                  <option>de_cbble</option>
                  <option>de_train</option>
                  <option>de_nuke</option>
                </b-form-select>
              </b-form-group>

              <!-- <b-form-group
                description
                label="Jogar 30 rounds (modo treino)?"
                v-b-tooltip.hover
                title="apenas usuários PREMIUM"
              >
                <b-form-select
                  :disabled="!currentUser.is_premium"
                  v-model="schedule.is_fullrounds_enabled"
                  class="mb-3"
                >
                  <option value="false">Não, jogar até um time fazer 16 (padrão)</option>
                  <option value="true">Sim, ambos os times jogam 15 rounds de cada lado</option>
                </b-form-select>
              </b-form-group>

              <b-form-group description label="FIGHTBACK Ativo">
                <b-form-select v-model="schedule.is_fightback_enabled" class="mb-3">
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </b-form-select>
              </b-form-group>

              <b-form-group
                description
                label="GOTV"
                v-b-tooltip.hover
                title="apenas usuários PREMIUM"
              >
                <b-form-select
                  :disabled="!currentUser.is_premium"
                  v-model="schedule.is_gotv_enabled"
                  class="mb-3"
                >
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </b-form-select>
              </b-form-group>-->

              <b-form-group description label="Data e Horário">
                <datetime
                  required
                  v-model="announce.starts_at"
                  type="datetime"
                  :minute-step="10"
                  input-class="form-control"
                  class="mb-3"
                ></datetime>
                <!-- :min-datetime="minScheduleDate"
                :max-datetime="maxScheduleDate"-->
              </b-form-group>
              <!-- O mapa será vetado dentro do servidor -->
            </form>
          </b-modal>
        </div>
        <div class="col-12 col-md-9">
          <!-- <h1>treinos</h1> -->

          <div class="practice-list">
            <div class="practice-item" v-for="team_practice in teams" :key="team_practice.id">
              <div class="practice-avatar" v-if="team_practice.team_a">
                <router-link
                  :to="{ name: 'TeamSingle', params: { id: team_practice.team_a.to_param }}"
                >
                  <b-img :src="team_practice.team_a.avatar.url"/>
                </router-link>
              </div>
              <div class="practice-content" v-if="team_practice.team_a">
                <router-link
                  :to="{ name: 'TeamSingle', params: { id: team_practice.team_a.to_param }}"
                >
                  <h4 v-html="team_practice.team_a.name"></h4>
                </router-link>
                <p>{{team_practice.team_a.team_level}}</p>
                <div class="practice-members">
                  <div class="member" v-for="user in team_practice.team_a.members" :key="user.slug">
                    <UserCard :user="user"></UserCard>
                  </div>
                </div>
              </div>

              <ul class="practice-maps">
                <li
                  @click="showModal(team_practice.id, team_practice.team_a.name, team_practice.team_a.id, map)"
                  :class="`${map}`"
                  v-for="map in team_practice.maps"
                  :key="map"
                >{{map}}</li>
              </ul>

              <!-- <div class="practice-cta">
                <b-button variant="info" size="md">treinar</b-button>
              </div>-->

              <div class="practice-date">em {{team_practice.starts_at_human}}</div>
            </div>
          </div>
          <div class="no-results" v-if="teams.length == 0">
            <h4>nenhum time procurando partida por agora - seja o primeiro!</h4>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="practiceInviteModal"
      hide-footer
      :title="`Treinar com ${this.challenge.teamName}`"
    >
      <div class="d-block text-center">
        <h3>Treinar {{challenge.chosen_map}}</h3>
      </div>

      <b-form-group description label="Seu time">
        <b-form-select required v-model="challenge.team_b_id" class="mb-3">
          <option v-for="team in currentUserTeams" :key="team.id" :value="team.slug">{{ team.name }}</option>
        </b-form-select>
      </b-form-group>

      <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Treinar</b-button>
    </b-modal>
  </div>
</template>

<script>
import TeamCard from "@/components/TeamCard";
import UserCard from "@/components/UserCard";
import Header from "@/components/Header";
import _ from "lodash";
export default {
  name: "PracticeList",
  metaInfo: {
    title: "Treino"
  },
  data() {
    return {
      teams: [],
      subscription: Object,
      q: "",
      page: 1,
      perPage: 0,
      currentUserTeams: [],
      totalRecords: 0,
      challenge: {
        teamName: "(time sem nome)",
        team_b_id: 0,
        id: 0,
        chosen_map: "",
        challengeTeamId: 0
      },
      announce: {
        team_a_id: 0,
        maps: ["de_mirage"],
        starts_at: ""
      }
    };
  },
  watch: {
    // page: function(newValue) {
    //   const params = new URLSearchParams(location.search)
    //   params.set('page', newValue)
    //   window.history.replaceState({}, '', `${location.pathname}?${params}`)
    // }
  },
  methods: {
    initialize() {
      this.loadRecords();
      this.$http.get("pages/my_account.json").then(response => {
        this.currentUserTeams = response.data.teams;
      });

      this.connect();
    },
    loadRecords() {
      this.$http.get(`team_practices.json`).then(response => {
        this.teams = response.data.teams;
      });
    },
    showModal(id, teamName, teamId, map) {
      this.challenge.id = id;
      this.challenge.teamName = teamName;
      this.challenge.team_b_id = teamId;
      this.challenge.chosen_map = map;
      this.$refs["practiceInviteModal"].show();
    },
    hideModal() {
      this.$http
        .post(`team_practices/${this.challenge.id}/accept.json`, this.challenge)
        .then(response => {
          this.$notify({
            group: "all",
            title:
              "Treino aceito! Os jogadores foram notificados e a partida está liberada na página inicial do site. BORA PRO SERVER :)",
            duration: -1000
          });
          this.$router.push("/");
          this.$refs["practiceInviteModal"].hide();
        });
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["practiceInviteModal"].toggle("#toggle-btn");
    },
    handleAnnounceSubmit() {
      // this.$refs.modalSchedule.hide()
      this.handleAnnounceOk();
    },
    handleAnnounceOk() {
      if (this.announce.teamId == 0) {
        return;
      }
      this.$http
        .post(`team_practices.json`, { team_practice: this.announce })
        .then(response => {
          this.$refs.modalAnnounce.hide();
          this.$notify({
            group: "all",
            title: "Postado - seu time está procurando treino"
          });
        })
        .catch(response => {
          this.$refs.modalAnnounce.hide();
        });
    },
    connect() {
      var self = this;
      this.subscription = this.$cable.subscriptions.create(
        { channel: "TeamPracticeChannel" },
        {
          received: function(data) {
            // if (data.action == "searching_update") {
            //   self.playersSearching = data.players_searching_count;
            // } else {
            //   console.log(data);
            // }
            self.loadRecords();
          }
        }
      );
      window.addEventListener(
        "beforeunload",
        function(event) {
          if (self.subscription.hasOwnProperty("unsubscribe")) {
            self.subscription.unsubscribe();
          }
        },
        false
      );
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    TeamCard,
    UserCard,
    Header
  }
};
</script>

<style lang="sass">
.practice-list
  display: flex
  flex-wrap: wrap
  // justify-content: space-between
  // margin-top: 20px
  // @media(min-width: 600px)
  //   margin: 0 10%
  
  .practice-item
    display: flex
    align-items: center
    width: 100%
    background: rgba(255, 255, 255, .1)
    padding: 10px
    margin: 10px
    border-radius: 4px

    display: grid
    grid-template-columns: 10% 50% 30% 20%
    grid-template-rows: 100%
    grid-template-areas: "avatar content maps cta"

    // align-items: center

    position: relative
    
    .practice-avatar
      grid-area: avatar
      figure
        width: 64px
        height: 64px
        overflow: hidden
        margin: 0
      // margin-bottom: 0
      img
        width: 100%
        height: auto
        border-radius: 250%
          
    .practice-content
      grid-area: content
      // margin-left: 10px
      color: white
      transition: all .2s
      // height: 100%
      // align-items: center
      a
        color: white
        h4
          margin-bottom: 0
        &:hover
          text-decoration: none
          h4
            // transform: scale(1.05)
            color: #eee
            transition: all .1s
      p
        margin: 0
        font-size: 12px
      .practice-members
        display: flex
        flex-wrap: wrap
        .user-card
          width: 32px
          height: 32px
      
    .practice-maps
      grid-area: maps
      list-style: none
      padding: 0
      margin: 0
      li
        margin: 2px
        padding: 4px 10px
        border-radius: 4px
        color: rgba(255, 255, 255, .7)
        font-size: 12px
        transition: all .1s
        &:hover
          color: white
          font-weight: bold
          transform: scale(1.05, 1.02)
          cursor: pointer
    
    .practice-cta
      grid-area: cta
      height: 100%
      align-items: center
      display: flex
      padding: 25px 10px
      justify-content: center
    
    .practice-date
      position: absolute
      top: 5px
      right: -2px
      background: rgba(255, 255, 255, 0.4)
      color: #fff
      padding: 2px 7px
      border-top-left-radius: 4px
      border-bottom-left-radius: 4px
      box-shadow: 1px 1px 1px 1px #333
      font-size: 14px

    &:hover
      // text-decoration: none
      background: rgba(255, 255, 255, .2)
      transform: scale(1.02)
      transition: all .3s ease
  
</style>
